export default function SudokuIcon() {
  const nums: [number, number, string, string][] = [
    [0, 0, '5', '#16213D'],
    [2, 0, '3', '#1F6FFF'],
    [1, 1, '7', '#16213D'],
    [0, 2, '9', '#1F6FFF'],
    [2, 2, '1', '#16213D'],
  ];
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="4" y="4" width="56" height="56" rx="8" fill="#F5F7FD" stroke="#2F58B8" strokeWidth="4" />
      <rect x="23.5" y="23.5" width="17" height="17" fill="#FFE27A" />
      <path d="M22.7 6v52M41.3 6v52M6 22.7h52M6 41.3h52" stroke="#2F58B8" strokeWidth="2.5" />
      {nums.map(([x, y, n, c]) => (
        <text
          key={`${x}${y}`}
          x={13.3 + x * 18.7}
          y={20 + y * 18.7}
          textAnchor="middle"
          fontSize="15"
          fontWeight="900"
          fontFamily="Arial, sans-serif"
          fill={c}
        >
          {n}
        </text>
      ))}
      <g fill="#FF8A1F" fontSize="6" fontWeight="700" fontFamily="Arial, sans-serif">
        <text x="45" y="30">2</text>
        <text x="53" y="30">4</text>
        <text x="45" y="37">6</text>
      </g>
    </svg>
  );
}
